
import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import AddVariant from "../../modules/variant/AddVariant";
import VariantManagement from "../../modules/variant/VariantManagement";
import UpdateVariant from "../../modules/variant/UpdateVariant";

const GenerateVariantModuleRoutes = () => {

    const routes: any = [
        <Route path={'/variants/:product/add'} element={
            <AuthMiddleware children={<AddVariant/>}/>
        }/>,
        <Route path={'/variants/:product/details/:id'} element={
            <AuthMiddleware children={<UpdateVariant/>}/>
        }/>
    ];



    return routes;
}

export default GenerateVariantModuleRoutes;
